import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { InvestmentPlanPage } from '../pages/InvestmentPlanPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/investment-plan')({
  component: InvestmentPlan,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
})

function InvestmentPlan() {
  return (
    <MainLayout>
      <InvestmentPlanPage />
    </MainLayout>
  )
}
